var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaMcpa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 20,
    viewBox: "0 0 35.57 8.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #82c655;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.54,.1V8.52h-2.05V3.47l-1.88,5.05h-1.66L2.05,3.46v5.06H0V.1H2.42l2.36,5.83L7.13,.1h2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.21,2.07c.36-.65,.86-1.16,1.51-1.52,.64-.36,1.37-.55,2.19-.55,1,0,1.86,.26,2.57,.79,.71,.53,1.19,1.25,1.43,2.16h-2.26c-.17-.35-.41-.62-.71-.8-.31-.18-.66-.28-1.05-.28-.63,0-1.14,.22-1.54,.66-.39,.44-.59,1.03-.59,1.76s.2,1.32,.59,1.76c.39,.44,.9,.66,1.54,.66,.39,0,.74-.09,1.05-.28,.31-.18,.55-.45,.71-.8h2.26c-.24,.91-.72,1.63-1.43,2.15-.71,.52-1.57,.79-2.57,.79-.82,0-1.55-.18-2.19-.55-.64-.36-1.15-.87-1.51-1.52-.36-.65-.54-1.39-.54-2.22s.18-1.57,.54-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.24,4.15c-.22,.4-.57,.73-1.03,.98-.46,.25-1.04,.37-1.73,.37h-1.27v3.02h-2.05V.1h3.32c.67,0,1.24,.12,1.7,.35,.46,.23,.81,.55,1.04,.96,.23,.41,.35,.88,.35,1.4,0,.49-.11,.93-.34,1.34Zm-2.04-.56c.19-.18,.29-.44,.29-.78s-.1-.6-.29-.78c-.19-.18-.48-.28-.88-.28h-1.12V3.86h1.12c.39,0,.68-.09,.88-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.89,7.03h-3.14l-.5,1.49h-2.15L30.14,.1h2.38l3.05,8.42h-2.17l-.5-1.49Zm-.53-1.58l-1.04-3.08-1.03,3.08h2.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaMcpa);
export default __webpack_public_path__ + "static/media/da_mcpa.28d1e46b42b084e1632c7339c384a8a6.svg";
export { ForwardRef as ReactComponent };